import { useMemo, useState, useEffect } from "react";
import ButtonComponent from "../../../../components/common/button/Button";
import { MultiDropdown } from "../../../../components/common/MultiDropdown";
import TopSection from "../../../LT/TopSection";
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import data from "../../../../common/NewForecastData.json";
import Dropdown from "../../../../components/common/Dropdown";
import DatePicker from "../../../../components/common/DatePicker";
import "./CPSBuyerForecast.css";
import CPSBuyerDataTable from "./CPSBuyerDataTable";
import { useDispatch, useSelector } from "react-redux";
import { getBuyerDropdownFilter } from "../../../../redux/actions/BuyerDropdownFilterSlice";
import { getBuyerDropdownFilterEndpoint, getBuyerForecastSearchTableEndpoint, getBuyerForecastTableEndpoint } from "../../../../common/endpoints";
import { getBuyerForecastTableData } from "../../../../redux/actions/getBuyerForecastTableData";
import { getBuyerForecastSearchTable } from "../../../../redux/actions/BuyerForecastSearchTableSlice";
import { Box, Typography, Drawer, Button, Badge } from "@mui/material";
import FilterScreen from "../../../../components/common/FilterScreen";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from "@mui/icons-material/Close";

const filterConfig = [
  {
    key: "parentVendorName",
    label: "Parent Vendor Name",
  },
  {
    key: "vendorCode",
    label: "Vendor Code",
    codeField: "vendorCode",
    nameField: "supplierName",
  },

  {
    key: "plant",
    label: "Plant",
    codeField: "plant",
    nameField: "plantName",
    extraField: "country",
  },

  {
    key: "country",
    label: "Country",
    codeField: "country",
    nameField: "countryName",
  },

  {
    key: "tccMaterialNumber",
    label: "TCCC Material Number",
  },
  {
    key: "ingredientName",
    label: "Material Description",
  },
  {
    key: "purchasingGroup",
    label: "Purchase Group",
    codeField: "purchasingGroup",
    nameField: "purchasingGroupDesc",
  },

  {
    key: "businessCategory",
    label: "Business Category",
  },
  {
    key: "scode",
    label: "External Material Group",
  },
  {
    key: "mrpController",
    label: "MRP Controller",
    codeField: "mrpController",
    nameField: "mrpControllerName",
  },
  {
    key: "snpPlanner",
    label: "GMP",
    codeField: "snpPlanner",
    nameField: "snpPlannerDescription",
  }
];

const CPSBuyerForecast = () => {
  const stateSelectorTableData = useSelector((state) => state.getBuyerForecastTableData);
  const searchTableSelector = useSelector((state) => state.getBuyerForecastSearchTable);

  const [isExpanded, setIsExpanded] = useState(false); // true = show all dropdowns
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    parentVendorName: [],
    supplierPIN: [],
    vendorCode: [],
    ingredientName: [],
    tccMaterialNumber: [],
    plant: [],
    purchasingGroup: [],
    businessCategory: [],
    packSize: [],
    incoterm: [],
    incoterm1: [],
    country: [],
    materialGroup: [],
    materialGroupDesc: [],
    plannerCode: [],
    snpPlanner: [],
    mrpController: [],
    scode: [],
  });

  const [forecastTableData, setForecastTableData] = useState([]);
  const [selectedViewBy, setSelectedViewBy] = useState("Monthly");
  const [selectedStartingFrom, setSelectedStartingFrom] = useState();
  const [selectedViewByOptions, setSelectedViewByOptions] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [keyFigureMappingCPS, setKeyFigureMappingCPS] = useState();
  const [keyFigureMappingDPS, setKeyFigureMappingDPS] = useState();

  const [openFiltersDrawer, setOpenFiltersDrawer] = useState(false);

  useEffect(() => {
    getBuyerFilterList();
  }, []); // trigger on dropdown change

  const isFilterApplied = Object.values(formData).some(value => value.length > 0);

  useEffect(() => {
    if (!isFilterApplied) {
      getBuyerForecastTable(selectedViewBy, selectedStartingFrom);
    } else {
      getBuyerForecastSearchDataTable(selectedViewBy, selectedStartingFrom);
    }
  }, []);

  const getBuyerFilterList = async () => {
    const loggedInUserEmail = localStorage.getItem("userEmail");
    try {
      const responseBuyerData = await dispatch(getBuyerDropdownFilter({
        dynamicEndpoint: `${getBuyerDropdownFilterEndpoint}/${loggedInUserEmail}`,
      }));
      if (responseBuyerData?.meta?.requestStatus === 'fulfilled') {
        const list = responseBuyerData?.payload;
        setDropdownData(list)
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  function filterDataByValue(selectedValue, itemValue) {
    if (!selectedValue || selectedValue.length === 0) return true; // If no filter selected, allow all data to match
    return selectedValue.includes(itemValue); // Check if item value is in selected filter values
  }

  // // Use optional chaining (?.) to safely check for undefined fields in formData
  // const filtered = dropdownData.filter(row => {
  //   return (
  //     filterDataByValue(formData.parentVendorName?.map(f => f.value), row.parentVendorName) &&
  //     filterDataByValue(formData.vendorCode?.map(f => f.value), row.vendorCode) &&
  //     filterDataByValue(formData.plant?.map(f => f.value), row.plant) &&
  //     filterDataByValue(formData.country?.map(f => f.value), row.country) &&
  //     filterDataByValue(formData.tccMaterialNumber?.map(f => f.value), row.tccMaterialNumber) &&
  //     filterDataByValue(formData.ingredientName?.map(f => f.value), row.ingredientName) &&
  //     filterDataByValue(formData.supplierPIN?.map(f => f.value), row.supplierPIN) &&
  //     filterDataByValue(formData.businessCategory?.map(f => f.value), row.businessCategory) &&
  //     filterDataByValue(formData.incoterm?.map(f => f.value), row.incoterm) &&
  //     filterDataByValue(formData.incoterm1?.map(f => f.value), row.incoterm1) &&
  //     filterDataByValue(formData.plantName?.map(f => f.value), row.plantName) &&
  //     filterDataByValue(formData.purchasingGroup?.map(f => f.value), row.purchasingGroup) &&
  //     filterDataByValue(formData.parentVendorName?.map(f => f.value), row.parentVendorName) &&
  //     filterDataByValue(formData.supplierName?.map(f => f.value), row.supplierName) &&
  //     filterDataByValue(formData.scode?.map(f => f.value), row.scode) &&
  //     filterDataByValue(formData.materialGroup?.map(f => f.value), row.materialGroup) &&
  //     filterDataByValue(formData.materialGroupDesc?.map(f => f.value), row.materialGroupDesc) &&
  //     (
  //       !formData.mrpController?.length ||
  //       formData.mrpController.some(
  //         f => f.value === row.mrpController && f.label.includes(row.mrpControllerName)
  //       )
  //     ) &&
  //     filterDataByValue(formData.snpPlanner?.map(f => f.value), row.snpPlanner)
  //   );
  // });

  // // Transform the data to the desired format
  // const transformedData = filtered?.map(item => ({
  //   supplier: item.vendorCode,
  //   material: item.tccMaterialNumber,
  //   plant: item.plant
  // }));

  const getSearchRequestBody = (viewByParam, startDateParam, updatedFormData) => {
    const loggedInUserEmail = localStorage.getItem("userEmail");
    const dayjsObj = dayjs(startDateParam); // This is your Dayjs object
    const year = dayjsObj.year(); // 2025
    const month = (dayjsObj.month() + 1).toString().padStart(2, '0'); // 10, but we need it to be 01-12
    const day = dayjsObj.date().toString().padStart(2, '0'); // 31
    const formattedDate = `${year}-${month}-${day}`;
    const categories = updatedFormData?.businessCategory?.map(item => item.value);

    const filteredData =
      dropdownData?.filter((row) => {
        return (
          filterDataByValue(
            updatedFormData?.parentVendorName?.map(
              (f) => f.value
            ),
            row.parentVendorName
          ) &&

          filterDataByValue(
            updatedFormData?.vendorCode?.map(
              (f) =>
                f.actualValue ??
                f.value
            ),
            row.vendorCode
          ) &&

          filterDataByValue(
            updatedFormData?.plant?.map(
              (f) =>
                f.actualValue ??
                f.value
            ),
            row.plant
          ) &&

          filterDataByValue(
            updatedFormData?.country?.map(
              (f) => f.value
            ),
            row.country
          ) &&

          filterDataByValue(
            updatedFormData?.tccMaterialNumber?.map(
              (f) => f.value
            ),
            row.tccMaterialNumber
          ) &&

          filterDataByValue(
            updatedFormData?.ingredientName?.map(
              (f) => f.value
            ),
            row.ingredientName
          ) &&

          filterDataByValue(
            updatedFormData?.supplierPIN?.map(
              (f) => f.value
            ),
            row.supplierPIN
          ) &&

          filterDataByValue(
            updatedFormData?.businessCategory?.map(
              (f) => f.value
            ),
            row.businessCategory
          ) &&

          filterDataByValue(
            updatedFormData?.incoterm?.map(
              (f) => f.value
            ),
            row.incoterm
          ) &&

          filterDataByValue(
            updatedFormData?.purchasingGroup?.map(
              (f) => f.value
            ),
            row.purchasingGroup
          ) &&

          filterDataByValue(
            updatedFormData?.incoterm1?.map(
              (f) => f.value
            ),
            row.incoterm1
          ) &&

          filterDataByValue(
            updatedFormData?.plantName?.map(
              (f) => f.value
            ),
            row.plantName
          ) &&

          filterDataByValue(
            updatedFormData?.parentVendorName?.map(
              (f) => f.value
            ),
            row.parentVendorName
          ) &&

          filterDataByValue(
            updatedFormData?.supplierName?.map(
              (f) => f.value
            ),
            row.supplierName
          ) &&

          filterDataByValue(
            updatedFormData?.scode?.map(
              (f) => f.value
            ),
            row.scode
          ) &&

          (
            !updatedFormData?.mrpController
              ?.length ||

            updatedFormData?.mrpController.some(
              (f) =>
                f.value ===
                row.mrpController &&
                f.label.includes(
                  row.mrpControllerName
                )
            )
          ) &&

          filterDataByValue(
            updatedFormData?.snpPlanner?.map(
              (f) => f.value
            ),
            row.snpPlanner
          )
        );
      });

    const transformedData =
      filteredData.map((item) => ({
        supplier:
          item.vendorCode,

        material:
          item.tccMaterialNumber,

        plant:
          item.plant,
      }));

    return {
      userEmail: loggedInUserEmail,
      viewBy: viewByParam,
      startDate: formattedDate,
      businessCategory: categories,  // Use the formatted date string
      filter: transformedData,  // Add the filters array
    };
  };

  const getBuyerForecastTable = async (viewByParam, startDateParam) => {
    const loggedInUserEmail = localStorage.getItem("userEmail");
    let formattedDate = "";

    if (startDateParam) {
      const dayjsObj = dayjs(startDateParam);
      formattedDate = `${dayjsObj.year()}-${String(dayjsObj.month() + 1).padStart(2, "0")}-${String(dayjsObj.date()).padStart(2, "0")}`;
    }
    try {
      const responseBuyerForecastData = await dispatch(getBuyerForecastTableData({
        dynamicEndpoint: `${getBuyerForecastTableEndpoint}/${loggedInUserEmail}`,
        params: {
          startDate: formattedDate,
          viewBy: viewByParam
        }
      }));

      if (responseBuyerForecastData?.meta?.requestStatus === 'fulfilled') {
        const tableData = responseBuyerForecastData?.payload;
        setForecastTableData(tableData?.forecast ?? []);
        const hasDpsData = tableData?.forecast?.some(item => item?.businessCategory === "DPS") ?? false;
        setSelectedViewByOptions(hasDpsData ? ["Monthly", "Yearly"] : ["Weekly", "Monthly", "Yearly", "Hybrid"])
        setSelectedViewBy(hasDpsData ? "Monthly" : "Weekly");
        setKeyFigureMappingCPS(tableData.keyFiguresCps);
        setKeyFigureMappingDPS(tableData.keyFiguresDps);
        setSelectedStartingFrom(dayjs(tableData.startDate))
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const getBuyerForecastSearchDataTable = async (viewByParam, startDateParam, updatedFormData) => {
    const requestBody = getSearchRequestBody(viewByParam, startDateParam, updatedFormData);
    try {
      const responseBuyerForecastSearchData = await dispatch(getBuyerForecastSearchTable({
        dynamicEndpoint: `${getBuyerForecastSearchTableEndpoint}`,
        data: requestBody,
      }));

      if (responseBuyerForecastSearchData?.meta?.requestStatus === 'fulfilled') {
        const tableSearchData = responseBuyerForecastSearchData?.payload;
        setForecastTableData(tableSearchData?.forecast ?? []);
        const hasDpsData = tableSearchData?.forecast?.some(item => item?.businessCategory === "DPS") ?? false;
        setSelectedViewByOptions(hasDpsData ? ["Monthly", "Yearly"] : ["Weekly", "Monthly", "Yearly", "Hybrid"])
        setSelectedViewBy(hasDpsData ? "Monthly" : "Weekly");
        setKeyFigureMappingCPS(tableSearchData.keyFiguresCps);
        setKeyFigureMappingDPS(tableSearchData.keyFiguresDps);
        setSelectedStartingFrom(dayjs(tableSearchData.startDate))
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const isSearchEnabled = useMemo(() => {
    return Object.values(formData).some(
      (value) => Array.isArray(value) && value.length > 0
    );
  }, [formData]);

  // Utility to extract unique options
  const getUniqueValues = (data = [], key) => {
    if (!data?.length) return [];
    const invalidValues = ['', null, 'NULL', 'null', '<Null>', '<NULL>'];

    // For Plant dropdown, concatenate plantId, plantName, and country for label, but use only plantId as value
    if (key === "plant") {
      return [
        ...new Set(data.map(item => `${item.plant} | ${item.plantName} | ${item.country}`)
          .filter(value => !invalidValues.includes(value))
        )
      ].map(value => {
        const [plantId, plantName, country] = value.split(' | ');
        return {
          label: value,  // Full concatenated label
          value: plantId, // Use only plantId as value
          title: value,
        };
      });
    }

    if (key === "snpPlanner") {
      return [
        ...new Set(
          data
            .map(item => {
              const code = item.snpPlanner?.trim();
              const desc = item.snpPlannerDescription?.trim();

              if (!code || invalidValues.includes(code)) return null;

              return (!desc || invalidValues.includes(desc))
                ? code
                : `${code} | ${desc}`;
            })
            .filter(value => value && !invalidValues.includes(value))
        )
      ].map(value => {
        const [snpPlanner] = value.split(' | ');
        return {
          label: value,
          value: snpPlanner,
          title: value,
        };
      });
    }

    if (key === "mrpController") {
      return [
        ...new Set(
          data
            .map(item => {
              const code = item.mrpController?.trim();
              const desc = item.mrpControllerName?.trim();

              if (!code || invalidValues.includes(code)) return null;

              return (!desc || invalidValues.includes(desc))
                ? code
                : `${code} | ${desc}`;
            })
            .filter(value => value && !invalidValues.includes(value))
        )
      ].map(value => {
        const [mrpController] = value.split(' | ');
        return {
          label: value,
          value: mrpController,
          title: value,
        };
      });
    }

    if (key === "purchasingGroup") {
      return [
        ...new Set(
          data
            .map(item => {
              const code = item.purchasingGroup?.trim();
              const desc = item.purchasingGroupDesc?.trim();

              if (!code || invalidValues.includes(code)) return null;

              return (!desc || invalidValues.includes(desc))
                ? code
                : `${code} | ${desc}`;
            })
            .filter(value => value && !invalidValues.includes(value))
        )
      ].map(value => {
        const [purchasingGroup] = value.split(' | ');
        return {
          label: value,
          value: purchasingGroup,
          title: value,
        };
      });
    }
    // For Vendor dropdown, concatenate vendorCode and supplierName for label, but use only vendorCode as value
    if (key === "vendorCode") {
      return [
        ...new Set(data.map(item => `${item.vendorCode} | ${item.supplierName}`)
          .filter(value => !invalidValues.includes(value))
        )
      ].map(value => {
        const [vendorCode, supplierName] = value.split(' | ');
        return {
          label: value,  // Full concatenated label
          value: vendorCode, // Use only vendorCode as value
          title: value,
        };
      });
    }

    // For other fields, return unique values as usual
    const uniqueValues = [
      ...new Set(
        data
          .map((item) => item[key])
          .filter((value) => value !== undefined && !invalidValues.includes(value)) // <-- add value !== undefined
      )
    ];

    return uniqueValues.map((value) => ({
      label: value,
      value: value,
      title: value,
    }));
  };

  const handleSelectedItemsChange = (name, newSelectedItems) => {
    setFormData((prev) => ({
      ...prev,
      [name]: newSelectedItems,
    }));
  };

  const handleViewByDropdown = (e) => {
    const newViewBy = e.target.value;
    setSelectedViewBy(newViewBy);

    // if (isSearchEnabled) {
    //   getSupplierForecastSearchDataTable(newViewBy, selectedStartingFrom);
    // } else {
    //   getSupplierForecastTable(newViewBy, selectedStartingFrom);
    // }
  };
  // Get the first day of the current month (min date)
  const currentMonthStart = dayjs().startOf('month');
  const currentMonthToday = dayjs().startOf('day');
  // Get the last day of the next month (max date)
  // const nextMonthEnd = dayjs().add(1, 'month').endOf('month');
  const handleDateChange = (date) => {
    setSelectedStartingFrom(date);

    if (isSearchEnabled) {
      getBuyerForecastSearchDataTable(selectedViewBy, date);
    } else {
      getBuyerForecastTable(selectedViewBy, date);
    }
  };

  const onClickSearchButton = (updatedFormData) => {
    setIsExpanded(false)
    getBuyerForecastSearchDataTable(selectedViewBy, selectedStartingFrom, updatedFormData);
  };
  const onClickClearButton = () => {
    setIsExpanded(false)
    setFormData({
      parentVendorName: [],
      supplierPIN: [],
      vendorCode: [],
      ingredientName: [],
      tccMaterialNumber: [],
      plant: [],
      purchasingGroup: [],
      businessCategory: [],
      packSize: [],
      incoterm: [],
      incoterm1: [],
      country: [],
      materialGroup: [],
      materialGroupDesc: [],
      mrpController: [],
      snpPlanner: [],
      plannerCode: [],
      scode: []
    })
    getBuyerForecastTable(selectedViewBy, selectedStartingFrom);
  }

  const onRenderSearchCallback = (filters) => {
    const updatedFormData = {
      ...formData,
      ...filters,
    };

    setFormData(updatedFormData);
    onClickSearchButton(updatedFormData);
  };

  const onRenderClearCallback = (filters) => {
    const updatedFormData = {
      ...formData,
      ...filters,
    };

    setFormData(updatedFormData);
    onClickClearButton();
  }
  const appliedFiltersCount = Object.values(formData).filter(
    (value) => Array.isArray(value) && value.length > 0
  ).length;

  return (
    <div>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "Forecast" },
        ]}
        tabTitle="Forecast"
        hideTitle
      />
      <div className="main-container">
        <div className="filter-label">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // marginBottom: 20,
              marginTop: 10
            }}
          >
            {/* LEFT SIDE — Minimize / Maximize */}
            <Box
              onClick={() => setIsExpanded(prev => !prev)}
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 35,
                height: 35,
                borderRadius: "6px",
              }}
            >
              {/* <IconButton> */}
              <Badge badgeContent={appliedFiltersCount > 0 ? appliedFiltersCount : null} sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.6rem", // Smaller font size
                  height: "16px", // Adjust badge height
                  minWidth: "16px", // Adjust badge width
                  padding: "4px", // Adjust padding
                  background: '#000',
                  color: '#fff'
                },
              }}
              >
                {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Filters </Typography>
              </Badge>
              {/* </IconButton> */}
            </Box>
          </div>
          <div style={{ display: isExpanded ? "block" : "none" }}>
            <FilterScreen filterConfig={filterConfig} dropdownData={dropdownData} onRenderSearchCallback={onRenderSearchCallback} onRenderClearCallback={onRenderClearCallback} />
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: 13, justifyContent: 'flex-end', position: 'absolute', right: 70, marginTop: 13, alignItems: 'center' }}>
          {/* View By Dropdown */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p style={{ margin: 0, fontWeight: 'normal', fontSize: 13 }}>View by:</p> {/* Ensuring no extra margin on the label */}
            <div style={{ width: 120 }}>
              <Dropdown
                height="30px"
                fontSize='14px'
                sx={{
                  fontSize: '11px', // Ensure font size is 12px
                  fontWeight: 'normal', // Ensure font weight is normal
                  '& .MuiInputBase-root': {
                    fontSize: '12px', // Target the input base for consistent font size
                    fontWeight: 'normal', // Apply normal font weight to the input
                  },
                }}
                maxWidth="80%"
                value={selectedViewBy}
                name="selectedViewBy"
                options={selectedViewByOptions && selectedViewByOptions.length > 0 ? selectedViewByOptions.map(option => ({
                  label: option,     // The text displayed in the dropdown
                  value: option      // The value sent when an option is selected
                })) : [{ label: 'Weekly', value: "Weekly" }, { label: 'Monthly', value: "Monthly" }, { label: 'Yearly', value: "Yearly" }, { label: 'Hybrid', value: "Hybrid" }]}
                handleChange={handleViewByDropdown}
              />
            </div>
          </div>
          {/* Starting From Date Picker */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <p style={{ fontWeight: 'normal', fontSize: 12 }}>Starting from:</p>
              <div style={{ width: 100 }}>
                <DatePicker
                  name="Starting From"
                  value={selectedStartingFrom} // Ensure it's a dayjs object
                  onChange={handleDateChange}
                  height="30px"
                  width={150}
                  fontSize={13}
                  fontWeight="normal"
                  styles={{
                    fontSize: '12px',
                    fontWeight: 'normal',
                  }}
                  minDate={currentMonthStart}  // Disable previous months
                // maxDate={nextMonthEnd}  // Allow only dates from current to next month
                />
              </div>
            </div>
          </LocalizationProvider>
        </div>
        <div>
          <CPSBuyerDataTable forecastTableData={forecastTableData} isLoading={stateSelectorTableData?.loading || searchTableSelector?.loading} selectedStartingFrom={selectedStartingFrom} selectedViewBy={selectedViewBy} setSelectedViewBy={setSelectedViewBy} keyFigureMappingCPS={keyFigureMappingCPS} keyFigureMappingDPS={keyFigureMappingDPS} selectedViewByOptions={selectedViewByOptions} setSelectedViewByOptions={setSelectedViewByOptions} getSupplierForecastTable={isSearchEnabled ? () => getBuyerForecastSearchDataTable(selectedViewBy, selectedStartingFrom, formData) : () => getBuyerForecastTable(selectedViewBy, selectedStartingFrom)} />
        </div>
      </div>
    </div>
  )
}

export default CPSBuyerForecast;
